export function buildCreateFindingChatPrompt({
  leadIn,
  instruction,
  traceThreadId,
  postAttackTraceId,
  signalId,
}: {
  leadIn: string;
  instruction: string;
  traceThreadId: string;
  postAttackTraceId?: string | null;
  signalId?: string | null;
}): string {
  return [
    leadIn.trimEnd(),
    '',
    instruction,
    `traceThreadId: ${traceThreadId}`,
    ...(postAttackTraceId ? [`postAttackTraceId: ${postAttackTraceId}`] : []),
    ...(signalId ? [`signalId: ${signalId}`] : []),
  ].join('\n');
}
